/* tslint:disable */
/* eslint-disable */
export enum RouterSorting {
  DeviceId = 'DEVICE_ID',
  SerialNumber = 'SERIAL_NUMBER',
  CraneId = 'CRANE_ID',
  Online = 'ONLINE',
  SimCardExpirationDate = 'SIM_CARD_EXPIRATION_DATE',
  RouterType = 'ROUTER_TYPE',
  CRequestTime = 'C_REQUEST_TIME',
  CGrantedTime = 'C_GRANTED_TIME',
  CGrantedUntil = 'C_GRANTED_UNTIL',
  CGrantedBy = 'C_GRANTED_BY',
  CFetchedTime = 'C_FETCHED_TIME',
  FwTargetVersion = 'FW_TARGET_VERSION',
  FwDownloadAllowedTime = 'FW_DOWNLOAD_ALLOWED_TIME',
  FwDownloadAllowedBy = 'FW_DOWNLOAD_ALLOWED_BY',
  FwDownloadTime = 'FW_DOWNLOAD_TIME',
  FwInstalledTime = 'FW_INSTALLED_TIME',
  Tenant = 'TENANT'
}
